let query = Modernizr.mq('(min-width: 768px)');

export class Product
{

	constructor(){

		this.productImages = jQuery('.c-slider');
		this.change_images = jQuery('.js-change-image');

		this.slider();
		this.zoom();

		this.change_images.on('click', this.changeImage.bind(this));

		if(!query){
			jQuery('.js-change-image:first-child img').trigger('click');
		}
	}

	zoom(){

		if(query){
			jQuery('.js-big-image img').ezPlus({
				responsive : true,
				zoomWindowPosition: 11,
				respond: [
				{
					range: '100-600',
					zoomWindowPosition: 5,
					zoomWindowHeight: 200,
					zoomWindowWidth: window.innerWidth - 110
				}
				]
			});
		}else{

		}


	}

	slider(){

		this.productImages.slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 1000,
			fade: true,
			autoplay: true,
			autoplaySpeed: 2000,
			cssEase: 'linear'
		});

	}

	changeImage(e){

		jQuery('#zoom_image-zoomContainer').remove();

		let _self = e.target;
		let _self_big = jQuery('.js-big-image');

		let img_zoom = _self.dataset.zoom;
		let img_original = (_self.dataset.original);
		let img_small = encodeURI(_self.src);

		let orig_img  = _self_big.attr('data-original');
		let orig_img_small  = _self_big.attr('data-small');

		if(query){
			_self_big.html('<img id="zoom_image" src="'+img_original+'" data-zoom-image="'+img_original+'"/>');
		}else{
			_self_big.html('<a href="'+img_original+'" data-lightbox="detail"><img id="zoom_image" src="'+img_original+'" data-zoom-image="'+img_original+'"/></a>');
		}

		_self_big.attr('data-original', img_original);
		_self_big.attr('data-small', img_small);

		if(img_zoom > 1){
			this.zoom();
		}

	}


}



// WEBPACK FOOTER //
// ./src/js/modules/product.js